import { Action, ActionWithoutPayload, Message } from "types/redux"
import {
  CONTACTLESS_PAYMENT_WAITING_STAFF,
  CONTACTLESS_PAYMENT_CREATE_REQUEST,
  CONTACTLESS_PAYMENT_CREATE_SUCCESS,
  CONTACTLESS_PAYMENT_CREATE_ERROR,
  CONTACTLESS_PAYMENT_POLL_SUCCESS,
  CONTACTLESS_PAYMENT_POLL_ERROR,
  CONTACTLESS_PAYMENT_POLL_TIMEOUT,
  CONTACTLESS_PAYMENT_POLL_CANCEL,
  CONTACTLESS_PAYMENT_RESET,
  READER_LINK_QR_REQUEST,
  READER_LINK_QR_SUCCESS,
  READER_LINK_QR_ERROR,
  READER_CHECK_LINKED_REQUEST,
  READER_CHECK_LINKED_SUCCESS,
  READER_CHECK_LINKED_ERROR,
  READER_GET_DEVICE_MODELS_REQUEST,
  READER_GET_DEVICE_MODELS_SUCCESS,
  READER_GET_DEVICE_MODELS_ERROR,
  READER_GET_DEVICE_MODELS_POLL_REQUEST,
  READER_GET_DEVICE_MODELS_POLL_SUCCESS,
  READER_DELETE_DEVICE_MODEL_REQUEST,
  READER_DELETE_DEVICE_MODEL_SUCCESS,
  READER_DELETE_DEVICE_MODEL_ERROR,
  PaymentState,
  CONTACTLESS_PAYMENT_WAITING_STAFF_SUCCESS,
} from "./constants"

export interface ContactlessPaymentCreateResponse {
  payment_intent_id: string
  client_secret: string
}

export interface ContactlessPaymentPaymentRequest {
  relative_id: number | null
  amount: number | null
}

export interface PaymentStatusResponse {
  state: PaymentState
}

export interface ReaderLinkQRResponse {
  token: string
  duration: number
}

export interface ReaderCheckLinkedResponse {
  readers_ids: Array<string>
}

// Device model with its information
export interface DeviceModel {
  name: string
  reader_uuid: string
  enabled: boolean
}

// Raw API response
export interface ReaderGetDeviceModelsApiResponse {
  status: string
  device_models: Array<DeviceModel>
}

// Type pour le store (tableau de DeviceModel)
export type ReaderGetDeviceModelsResponse = Array<DeviceModel>

export const contactlessPaymentActions = {
  waitingStaff: (): ActionWithoutPayload => ({
    type: CONTACTLESS_PAYMENT_WAITING_STAFF,
  }),
  waitingStaffSuccess: (): ActionWithoutPayload => ({
    type: CONTACTLESS_PAYMENT_WAITING_STAFF_SUCCESS,
  }),
  createRequest: (): ActionWithoutPayload => ({
    type: CONTACTLESS_PAYMENT_CREATE_REQUEST,
  }),
  createSuccess: (payload: ContactlessPaymentCreateResponse): Action<ContactlessPaymentCreateResponse> => ({
    type: CONTACTLESS_PAYMENT_CREATE_SUCCESS,
    payload,
  }),
  createError: (error: string): Action<Message> => ({
    type: CONTACTLESS_PAYMENT_CREATE_ERROR,
    payload: { type: "error", text: error },
  }),

  pollSuccess: (): ActionWithoutPayload => ({
    type: CONTACTLESS_PAYMENT_POLL_SUCCESS,
  }),
  pollError: (error: string): Action<Message> => ({
    type: CONTACTLESS_PAYMENT_POLL_ERROR,
    payload: { type: "error", text: error },
  }),
  pollTimeout: (): ActionWithoutPayload => ({
    type: CONTACTLESS_PAYMENT_POLL_TIMEOUT,
  }),
  pollCancel: (): ActionWithoutPayload => ({
    type: CONTACTLESS_PAYMENT_POLL_CANCEL,
  }),

  reset: (): ActionWithoutPayload => ({
    type: CONTACTLESS_PAYMENT_RESET,
  }),

  readerLinkQRRequest: (): ActionWithoutPayload => ({
    type: READER_LINK_QR_REQUEST,
  }),
  readerLinkQRSuccess: (payload: ReaderLinkQRResponse): Action<ReaderLinkQRResponse> => ({
    type: READER_LINK_QR_SUCCESS,
    payload,
  }),
  readerLinkQRError: (error: string): Action<Message> => ({
    type: READER_LINK_QR_ERROR,
    payload: { type: "error", text: error },
  }),

  readerCheckLinkedRequest: (): ActionWithoutPayload => ({
    type: READER_CHECK_LINKED_REQUEST,
  }),
  readerCheckLinkedSuccess: (payload: ReaderCheckLinkedResponse): Action<ReaderCheckLinkedResponse> => ({
    type: READER_CHECK_LINKED_SUCCESS,
    payload,
  }),
  readerCheckLinkedError: (error: string): Action<Message> => ({
    type: READER_CHECK_LINKED_ERROR,
    payload: { type: "error", text: error },
  }),

  readerGetDeviceModelsRequest: (): ActionWithoutPayload => ({
    type: READER_GET_DEVICE_MODELS_REQUEST,
  }),
  readerGetDeviceModelsSuccess: (payload: ReaderGetDeviceModelsResponse): Action<ReaderGetDeviceModelsResponse> => ({
    type: READER_GET_DEVICE_MODELS_SUCCESS,
    payload,
  }),
  readerGetDeviceModelsError: (error: string): Action<Message> => ({
    type: READER_GET_DEVICE_MODELS_ERROR,
    payload: { type: "error", text: error },
  }),
  readerGetDeviceModelsPollRequest: (): ActionWithoutPayload => ({
    type: READER_GET_DEVICE_MODELS_POLL_REQUEST,
  }),
  readerGetDeviceModelsPollSuccess: (payload: ReaderGetDeviceModelsResponse): Action<ReaderGetDeviceModelsResponse> => ({
    type: READER_GET_DEVICE_MODELS_POLL_SUCCESS,
    payload,
  }),

  readerDeleteDeviceModelRequest: (deviceModel: DeviceModel): Action<DeviceModel> => ({
    type: READER_DELETE_DEVICE_MODEL_REQUEST,
    payload: deviceModel,
  }),
  readerDeleteDeviceModelSuccess: (): ActionWithoutPayload => ({
    type: READER_DELETE_DEVICE_MODEL_SUCCESS,
  }),
  readerDeleteDeviceModelError: (error: string): Action<Message> => ({
    type: READER_DELETE_DEVICE_MODEL_ERROR,
    payload: { type: "error", text: error },
  }),
}

export default contactlessPaymentActions

